import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Inbox = () => {
  const [messages, setMessages] = useState([]);
  const [sentMessages, setSentMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('inbox');
  const navigate = useNavigate();

  // Get logged in user info
  const loggedInUser = JSON.parse(localStorage.getItem('user') || '{}');
  const username = loggedInUser.username || loggedInUser.email || '';

  useEffect(() => {
    setLoading(true);
    if (tab === 'inbox') {
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/inbox?user=${encodeURIComponent(username)}`)
        .then(res => res.json())
        .then(data => {
          setMessages(data.messages || []);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    } else if (tab === 'sent') {
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/sent?user=${encodeURIComponent(username)}`)
        .then(res => res.json())
        .then(data => {
          setSentMessages(data.messages || []);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [username, tab]);

  const renderTable = (data, isInbox) => (
    <table style={styles.table}>
      <thead>
        <tr>
          <th style={styles.th}>{isInbox ? 'From' : 'To'}</th>
          <th style={styles.th}>Subject</th>
          <th style={styles.th}>Message</th>
          <th style={styles.th}>Date</th>
          <th style={styles.th}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map(msg => (
          <tr key={msg.id}>
            <td style={styles.td}>{isInbox ? msg.from_user : msg.to_user}</td>
            <td style={{
              ...styles.td,
              fontWeight: isInbox && (msg.is_read === false || msg.is_read === 0) ? 'bold' : 'normal'
            }}>
              {msg.subject}
            </td>
            <td style={styles.td}>{msg.message}</td>
            <td style={styles.td}>{new Date(msg.sent_at).toLocaleString()}</td>
            <td style={styles.td}>
              {isInbox && (
                <button
                  style={styles.detailsBtn}
                  onClick={async () => {
                    // Mark as read in backend
                    await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/mail/${msg.id}/read`, {
                      method: 'PUT',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ is_read: true }),
                    });
                    // Update in UI
                    setMessages(prev =>
                      prev.map(m =>
                        m.id === msg.id ? { ...m, is_read: true } : m
                      )
                    );
                    navigate(`/maildetails/${msg.id}`, { state: { mail: { ...msg, is_read: true } } });
                  }}
                >
                  Open
                </button>
              )}
              <button
                style={styles.deleteBtn}
                onClick={async () => {
                  if (window.confirm('Are you sure you want to delete this message?')) {
                    await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/mail/${msg.id}`, {
                      method: 'DELETE',
                    });
                    if (isInbox) {
                      setMessages(prev => prev.filter(m => m.id !== msg.id));
                    } else {
                      setSentMessages(prev => prev.filter(m => m.id !== msg.id));
                    }
                  }
                }}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Inbox</h2>
      <button
        style={styles.composeBtn}
        onClick={() => navigate('/mail')}
      >
        Compose Mail
      </button>
      <div style={styles.tabRow}>
        <button
          style={{
            ...styles.tabBtn,
            background: tab === 'inbox' ? '#4078c0' : '#f5f6fa',
            color: tab === 'inbox' ? '#fff' : '#4078c0',
            fontWeight: tab === 'inbox' ? 'bold' : 'normal',
          }}
          onClick={() => setTab('inbox')}
        >
          Inbox
        </button>
        <button
          style={{
            ...styles.tabBtn,
            background: tab === 'sent' ? '#4078c0' : '#f5f6fa',
            color: tab === 'sent' ? '#fff' : '#4078c0',
            fontWeight: tab === 'sent' ? 'bold' : 'normal',
          }}
          onClick={() => setTab('sent')}
        >
          Sent
        </button>
      </div>
      {loading ? (
        <div style={styles.loading}>Loading messages...</div>
      ) : (tab === 'inbox' ? (
        messages.length === 0 ? (
          <div style={styles.empty}>No messages found.</div>
        ) : (
          renderTable(messages, true)
        )
      ) : (
        sentMessages.length === 0 ? (
          <div style={styles.empty}>No sent messages found.</div>
        ) : (
          renderTable(sentMessages, false)
        )
      ))}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  title: {
    marginBottom: '28px',
    color: '#4078c0',
    fontSize: '1.7rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  composeBtn: {
    background: '#388e3c',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #c8e6c9',
    transition: 'background 0.2s',
    marginBottom: '24px',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  tabRow: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '18px',
    gap: '8px',
  },
  tabBtn: {
    padding: '10px 32px',
    border: 'none',
    borderRadius: '8px 8px 0 0',
    fontSize: '1.08rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    outline: 'none',
  },
  loading: {
    textAlign: 'center',
    color: '#4078c0',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginTop: '40px',
    letterSpacing: '1px',
  },
  empty: {
    textAlign: 'center',
    color: '#888',
    fontSize: '1.1rem',
    marginTop: '32px',
    fontStyle: 'italic',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '18px',
    fontSize: '1.05rem',
  },
  th: {
    background: '#f5f6fa',
    color: '#8d6e36',
    fontWeight: 'bold',
    fontSize: '1.08rem',
    padding: '12px 8px',
    borderBottom: '2px solid #e0cfa0',
    textAlign: 'left',
  },
  td: {
    padding: '10px 8px',
    borderBottom: '1px solid #e0cfa0',
    fontSize: '1.05rem',
    textAlign: 'left',
    verticalAlign: 'top',
  },
  detailsBtn: {
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '6px 16px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    marginLeft: '8px',
  },
  deleteBtn: {
    background: '#c0392b',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '6px 16px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    marginLeft: '8px',
  },
};

export default Inbox;